import KnowYourTeam from './KnowYourTeam';

export default KnowYourTeam;
